import Footer from "../../components/Footer/Footer";
import NavBar from "../../components/NavBar/NavBar";
import Title from "../../components/Title/Title";
import '../../styles/Source-Link.css';
import CustomButton from "../../components/Custom-Button/CustomButton";
export default function HeartMary() {

    return (
        <div>
            <NavBar/>
            <Title text={"Devoção ao Castíssimo Coração de São José"}/>

            <p className="info-text">
           A devoção ao coração de São José é menos antiga e formalizada. Na Bíblia, José é apresentado como um “homem justo” (Mt 1,19) e o justo patriarca da Sagrada Família, mas não há revelações públicas sobre seu coração. <br/>
           Só no século XX ele recebeu destaque especial: em 1870 Pio IX o declarou Padroeiro da Igreja, e nos séculos seguintes papas o chamaram de “Patrono dos operários” (Pio XII) e “Guardião do Redentor” (João Paulo II)[17]. <br/>
           Em 2020-2021, o Papa Francisco dedicou um Ano de São José (patris corde, 150º aniversário) para aprofundar sua imagem paterna na fé. <br/>
           Embora não exista nenhuma festa litúrgica do “Coração de São José”, surgiram orações e consagrações particulares populares que pedem sua intercessão através de seu “coração castíssimo” – símbolo de pureza e zelo paterno.
            </p> 

            <Title text={"Fundamentação Teológica"}/>
            <p className="info-text">: São José é venerado pela Igreja como o esposo da Virgem Maria e pai putativo de Jesus, exemplo de fidelidade à lei divina e obediência à vontade de Deus. <br/>
            O Papa Francisco ressalta em Patris Corde: “Com coração de pai: assim José amou a Jesus”, destacando seu amor ternamente paternal. <br/>
            Seu coração “castíssimo” significa o amor casto e despretensioso que exercia: protegeu e provia para Jesus e Maria, servindo silenciosamente ao mistério da Encarnação. <br/>
            A teologia católica considera São José como modelo de obediência, coragem e pureza de coração (Lc 2,22-24 mostra sua fidelidade ao Templo). <br/>
            Não há doutrina formal sobre o coração de José, mas os santos sempre o recomentaram: Santa Teresa d’Ávila, por exemplo, era sua devota fiel.
            </p>
            
            <Title text={"Práticas Devocionais"}/>
            <p className="info-text">As devoções a São José incluem orações próprias (Salve Rainha dos Santo Patriarca, Ladainha de São José), novenas e entronizações de sua imagem. <br/>
                Tradicionalmente, quartas-feiras são dedicadas a ele (dia da semana associado a São José), e o mês de março – culminando em sua festa de 19 de março – é especialmente dedicado a venerá-lo. <br/>
                Em 2021, muitas famílias e paróquias fizeram consagrações ao “Castíssimo Coração de São José”, seguindo pedidos de grupos devotos; embora não haja ato oficial universal, o Papa estimulou a todos a encontrarem em José um guia “discreto e oculto” nas dificuldades. <br/>
                Em resumo, as práticas marcam o amor filial a José: oração, imitação de suas virtudes (fé e silêncio obediente) e pedidos de sua proteção paterna sobre famílias e a Igreja.
            </p>

            <div className="btn-row">
            <CustomButton route={"/Sagrados-Coracoes"} text={"Voltar"}/>
            </div>
   
            <Footer/>
        </div>
    )
}